export const CHECKING = 'checking';
export const ERROR = 'error';
export const GOOD = 'good';
export const UNKNOWN = 'unknown';
export const WARNING = 'warning';
